import React, { useState, useEffect } from 'react';
import { POST_GET_WALLET_BALANCE, POST_TRANSFER_TO_WALLET, GET_PARTNER_INFO } from '../../Utils/appConstants';
import { postRequest } from '../../Utils/AppApi';
import { toast } from 'react-toastify';
import { isNumber } from '../../Utils/Common';
import PropagateLoader from "react-spinners/PropagateLoader";

function WalletBalance() {
    
    const [balance, setBalance] = useState(null);
    // const [khataBalance, setKhataBalance] = useState(null);
    const [loading, setLoading] = useState(true);
    const [searchText, setSearchText] = useState(null);
    const [amount, setAmount] = useState(null);
    const [searchButton, setSearchButton] = useState(true);
    const [partnerData, setPartnerData] = useState(null);
    // const [error, setError] = useState(null);

    async function fetchBalance() {
        try {
            postRequest(POST_GET_WALLET_BALANCE, {}).then((response) => {
                if (response.success === true) {
                    setBalance(response.data.walletBalance);
                    // setKhataBalance(response.data.khataBalance);
                    setLoading(false);
                    // toast.success(response.message);
                } else {
                    // toast.error(response.message);
                }
            }).catch(function (error) {
                // console.log(error)
            })
        } catch (err) {
            setLoading(false);
        }
    }

    async function fetchPartner() {
        setLoading(true);
        try {
            let payload = {};
            payload.search = searchText;
            postRequest(`${GET_PARTNER_INFO}`, payload).then((response) => {
                if (response.success === true) {
                    console.log("------", response.data)
                    setPartnerData(response.data[0])
                    // toast.success(response.message);
                } else {
                    // toast.error(response.message);
                }
                setLoading(false);
            }).catch(function (error) {
                // console.log(error)
                setLoading(false);
            })
        } catch (err) {
            // setError(err.message);
            setLoading(false);
        }
    }

    async function handleSubmit() {


        if(amount === null || amount === undefined || amount === '' || parseFloat(amount) <= 0){
            toast.error("Please enter valid amount");
            return;
        }
        try {
            setLoading(true);
            let payload = { amount: amount, userId: partnerData._id }
            postRequest(POST_TRANSFER_TO_WALLET, payload).then((response) => {
                if (response.success === true) {
                    fetchBalance();
                    setSearchText(null);
                    setPartnerData(null);
                    setLoading(false);
                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                    setLoading(false);

                }
            }).catch(function (error) {
                toast.error(error);
                setLoading(false);

                // console.log(error)
            })
        } catch (err) {
            // setError(err.message);
            setLoading(false);
        }
    }

    const handleSearch = (e) => {
        // console.log("searchText----",e.target.value)
        if (e.target.value.length === 9) {
            setSearchButton(false)
        } else {
            setSearchButton(true)
        }
        setSearchText(e.target.value);
    }

    useEffect(() => {
        fetchBalance();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (loading) {
        return <div className="content text-center" style={{ margin: "250px 0" }}>
            <PropagateLoader color="#5851D2" loading={loading} size={25} />
        </div>
    }

    return (
        <div className="content-wrapper pt-2">
            <div className="content-header my-0 py-0">
                <div className="container-fluid">
                    <div className="row mb-0 align-items-center">
                        <div className="col-sm-6">
                            <h1 className='page-title text-blue font-merriweather'>Settle To <span className='text-red'>Wallet</span></h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="container-fluid mt-2">
                    <div className="card">
                        <div className="card-body">
                            <div className='row'>
                                <h5 className="card-title">Current Balance: {balance !== null && parseFloat(balance) > 0 ? `Rs. ${balance?.toFixed(2)}` : 'Balance not available'}</h5>
                            </div>
                            {/* <div className='row'>
                                <h3 className="card-title">Khatabook Balance: {khataBalance !== null && parseFloat(khataBalance) > 0 ? `Rs. ${khataBalance?.toFixed(2)}` : 'Balance not available'}</h3>
                            </div> */}
                        </div>

                        <div className='card-body row mb-3'>
                            <div className="input-group">
                                <div className="col-md-4">
                                    <input className="form-control py-2 border" type="search" defaultValue={searchText} value={searchText} placeholder='Search ...' maxLength={9} onChange={(e) => handleSearch(e)} />
                                </div>
                                <div className="col-md-2">
                                    <button className="btn btn-primary" disabled={searchButton} type="button" onClick={() => fetchPartner()}>
                                        <i className="fa fa-search" /> Search
                                    </button>
                                </div>
                            </div>
                        </div>
                        {partnerData && <div className="container-fluid mt-5">
                            <div className="card">
                                <div className="card-header bg-primary text-white">
                                    User Details
                                </div>
                                <div className='row float-left col-md-12'>
                                    <div className='col-md-4'>
                                        <div className="card-body">
                                            <h5 className="card-title">{partnerData.name}</h5>
                                            <p className="card-text">
                                                <strong>Username:</strong> {partnerData.username}
                                            </p>
                                            <p className="card-text">
                                                <strong>Mobile:</strong> {partnerData.mobile}
                                            </p>
                                            {/* <p className="card-text">
                                                <strong>Role:</strong> {partnerData.role.name}
                                            </p> */}
                                            {/* <p className="card-text">
                                                <strong>Wallet Balance:</strong> {partnerData.walletbalances.balance.toFixed(2)}
                                            </p> */}
                                        </div>
                                    </div>
                                    <div className='col-md-8'>
                                        <div className='mt-3'>
                                            <div className="input-group">
                                                <div className="col-md-4">
                                                    <input className="form-control py-2 border" type="number" defaultValue={amount} onKeyDown={isNumber} value={amount} placeholder='Amount ...' maxLength={9} onChange={(e) => setAmount(e.target.value)} />
                                                </div>
                                                <div className="col-md-4">
                                                    <button className="btn btn-primary" type="button" onClick={() => handleSubmit()}>Tranfer Amount</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WalletBalance;